import React from 'react'
import { withRouter } from 'react-router'

import BreadCrumbs from '../BreadCrumbs/breadcrumbs'
import Markdown from '../Markdown/markdown'

import ClockIcon from '../../assets/icons/clock-icon'
import MailIcon from '../../assets/icons/mail-icon'
import FacebookIcon from '../../assets/icons/facebook-icon'
import TwitterIcon from '../../assets/icons/twitter-icon'


import './news.scss'

class Article extends React.Component {

  renderShareButtons() {
    const url = `https://hive.fi${this.props.location.pathname}`

    return (
      <div className="share-buttons-container">
        <a href={ `https://twitter.com/share?url=${url}` } target="_blank" className="share-button unstyled">
          <TwitterIcon/>
        </a>
        <a href={ `https://www.facebook.com/sharer/sharer.php?u=${url}` } target="_blank" className="share-button unstyled">
          <FacebookIcon/>
        </a>
        <a href={ `mailto:?subject=&body=${url}` } className="share-button unstyled">
          <MailIcon/>
        </a>
      </div>
    )
  } 

  renderImage(image) {
    if (image) {
      const { src, srcSet, title } = image.sizes
      return (  
        <div className="article-image-wrapper">
          <img src={ src } srcSet={ srcSet } className="feature-image" alt={ title } />
        </div>      
        
      )
    }

    return null
  }

  render() {
    const { lang, localization, content } = this.props
    const image = this.renderImage(content.featureImage)

    const parentPage = {
      path: lang === 'fi' ? '/fi/uutiset' : '/en/news',
      title: localization('global.articles')
    }

    const currentPage = { title: content.heading }

    return (
      <div className="page-article-container">
        <BreadCrumbs 
          lang={ lang }
          localization={ localization}
          currentPage={ currentPage }
          parentPage={ parentPage } />


        <h1>{ content.heading}</h1>

        <div className="date">
          <ClockIcon className="icon clock-icon" />
          <time className="created-at">{ content.createdAt }</time>
        </div>

        { image }

        <div className="content">
          <div className="article-social-wrapper-side">{ this.renderShareButtons() }</div>
          <Markdown content={ content.body.body } />
        </div>
        <div className="article-social-wrapper-sticky">{ this.renderShareButtons() }</div>
      </div>
    )
  }
}

export default withRouter(Article)


// WEBPACK FOOTER //
// ./src/components/News/article.js